function createObjectIndexation(index, previousIndex, propriete) {
  return {
    libelle: 'indexation.produit.produit.' + propriete,
    propriete: propriete,
    valueYearSelect: index ? index[propriete] : null,
    valueYearBeforeSelect: previousIndex ? previousIndex[propriete] : null,
  };
}

export default function genererTabProduitIndexation(indexation, previousIndexation) {
  if (!indexation) return [];
  const indexationTab = [];
  indexationTab.push(createObjectIndexation(indexation, previousIndexation, 'applicableLocation'));
  indexationTab.push(createObjectIndexation(indexation, previousIndexation, 'applicableTlpe'));
  indexationTab.push(createObjectIndexation(indexation, previousIndexation, 'applicableHonoraire'));
  indexationTab.push(createObjectIndexation(indexation, previousIndexation, 'applicableDivers'));
  return indexationTab;
}
